import { Box, Flex } from '@mantine/core';
import { ReactNode } from 'react';

import classes from './FormField.module.scss';

type FormFieldProps = {
  children: ReactNode;
  label?: string;
  withAsterisk?: boolean;
  Icon?: ReactNode;
  dataTestId?: string;
};

export function FormField(props: FormFieldProps) {
  const { children, label, withAsterisk, Icon, dataTestId } = props;

  return (
    <Box data-testid={dataTestId} className={classes.formField}>
      <Flex align="center" gap={0}>
        {Icon && <Box className={classes.icon}>{Icon}</Box>}
        <>
          {label && <label className={classes.label}>{label}</label>}
          {withAsterisk && (
            <Box component="span" className={classes.asterisk}>
              *
            </Box>
          )}
        </>
      </Flex>
      {children}
    </Box>
  );
}
